import React, { useMemo } from 'react';

import Select from '@shared/v2/components/Select';

import { Destination } from '@/v2/types/ui';

interface Props {
  value: string;
  destinations: Destination[];
  destinationNames: string[];
  onSubmit: () => void;
}

const TravellingTo = ({
  value,
  destinations,
  destinationNames,
  onSubmit,
}: Props) => {
  const options = useMemo(
    () => [
      { text: 'All locations', value: '' },
      ...destinations
        .filter((d) => !d.theme)
        .map((o) => ({ text: o.title, value: o.name }))
        .filter((v) => destinationNames && destinationNames.includes(v.value))
        .sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        }),
    ],
    [destinations, destinationNames],
  );

  return (
    <Select
      id="TRAVELLING_TO"
      data-testid="TRAVELLING_TO"
      value={value}
      options={options}
      disabled={destinations.length === 0}
      onSelectedChange={onSubmit}
      placeholder="Travelling to"
      prefix="To"
    />
  );
};

export default TravellingTo;
